import { useQuery } from "@tanstack/react-query";
import { ExportXlsx } from "../export-xlsx";

export const useExportRate = (filter: string) => {
  const { refetch } = useQuery({
    queryKey: ["Export"],
    queryFn: () => ExportXlsx("rates", filter),
    enabled: false,
  });

  return { refetch };
};
